export default function CoupounCardFloatPad(props: any) {
    return (
        <svg width="540" height="327" viewBox="0 0 540 327" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_2364_35887)">
                <path
                    d="M66.0525 157.316L53.374 156.886C52.5434 156.858 51.9363 157.662 52.1911 158.453L54.7773 166.482C55.0303 167.267 55.9821 167.569 56.6412 167.073L66.7336 159.474C67.6376 158.794 67.1835 157.355 66.0525 157.316Z"
                    fill="url(#paint0_linear_2364_35887)"
                    stroke="url(#paint1_linear_2364_35887)"
                    strokeWidth="0.4"
                />
                <circle
                    cx="83.1155"
                    cy="21.3231"
                    r="3.2"
                    transform="rotate(-34.3971 83.1155 21.3231)"
                    fill="url(#paint2_linear_2364_35887)"
                    stroke="url(#paint3_linear_2364_35887)"
                    strokeWidth="0.4"
                />
                <path
                    d="M375.955 31.1761L396.691 25.5997C397.494 25.3839 397.839 24.4372 397.364 23.7551L389.206 12.0388C388.734 11.3617 387.736 11.3515 387.25 12.0187L374.673 29.3114C374.007 30.2266 374.862 31.47 375.955 31.1761Z"
                    fill="url(#paint4_linear_2364_35887)"
                    stroke="url(#paint5_linear_2364_35887)"
                    strokeWidth="0.4"
                />
                <circle
                    cx="431.706"
                    cy="74.7053"
                    r="5.6227"
                    transform="rotate(3.06982 431.706 74.7053)"
                    fill="url(#paint6_linear_2364_35887)"
                    stroke="url(#paint7_linear_2364_35887)"
                    strokeWidth="0.4"
                />
                <circle
                    cx="488.371"
                    cy="224.37"
                    r="4.35339"
                    transform="rotate(3.06982 488.371 224.37)"
                    fill="url(#paint8_linear_2364_35887)"
                    stroke="url(#paint9_linear_2364_35887)"
                    strokeWidth="0.4"
                />
                <path
                    d="M320.266 179.11C320.381 178.902 320.368 178.66 320.288 178.42C320.207 178.179 320.052 177.914 319.839 177.633C319.414 177.07 318.731 176.401 317.851 175.672C316.088 174.211 313.504 172.479 310.515 170.82C307.527 169.16 304.69 167.882 302.518 167.159C301.434 166.797 300.505 166.571 299.802 166.508C299.451 166.476 299.144 166.484 298.898 166.543C298.652 166.602 298.439 166.719 298.324 166.926C298.208 167.134 298.222 167.376 298.302 167.616C298.382 167.857 298.538 168.122 298.75 168.403C299.176 168.966 299.859 169.635 300.739 170.364C302.501 171.825 305.085 173.557 308.074 175.216C311.063 176.876 313.899 178.154 316.071 178.877C317.156 179.239 318.084 179.465 318.787 179.528C319.138 179.56 319.445 179.552 319.692 179.493C319.938 179.434 320.151 179.317 320.266 179.11Z"
                    fill="url(#paint10_linear_2364_35887)"
                    stroke="url(#paint11_linear_2364_35887)"
                    strokeWidth="0.4"
                />
            </g>
            <defs>
                <linearGradient id="paint0_linear_2364_35887" x1="79.5756" y1="159.97" x2="70.7683" y2="176.775" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_2364_35887" x1="73.3672" y1="155.232" x2="75.4444" y2="162.201" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint2_linear_2364_35887" x1="86.1155" y1="14.7606" x2="90.8053" y2="21.5173" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint3_linear_2364_35887" x1="82.6992" y1="16.4385" x2="86.5701" y2="16.5586" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint4_linear_2364_35887" x1="356.581" y1="33.0446" x2="361.913" y2="4.72735" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint5_linear_2364_35887" x1="367.701" y1="37.169" x2="361.591" y2="27.9704" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint6_linear_2364_35887" x1="437.128" y1="62.8432" x2="445.605" y2="75.0563" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint7_linear_2364_35887" x1="430.953" y1="65.876" x2="437.95" y2="66.0931" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint8_linear_2364_35887" x1="492.525" y1="215.284" x2="499.018" y2="224.639" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint9_linear_2364_35887" x1="487.795" y1="217.607" x2="493.154" y2="217.774" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint10_linear_2364_35887" x1="286.801" y1="157.881" x2="294.285" y2="150.173" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint11_linear_2364_35887" x1="291.56" y1="163.538" x2="293.027" y2="160.934" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <clipPath id="clip0_2364_35887">
                    <rect width="540" height="327" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
